import { Fotter, OurTeam, Projects } from "../../components"

const AboutPage = () => {
  return (
    <>
      <section className="py-24 relative xl:mr-0 lg:mr-5 mr-0 mt-16">
        <div className="w-full max-w-7xl px-4 md:px-5 lg:px-5 mx-auto">
          <div className="w-full justify-start items-center xl:gap-12 gap-10 grid lg:grid-cols-1 grid-cols-1">
            <div className="w-full flex-col justify-center lg:items-start items-center gap-10 inline-flex">
              <div className="w-full flex-col justify-center items-start gap-8 flex">
                <div className="flex-col justify-start lg:items-start items-center gap-4 flex">
                  <h6 className="text-gray-400 text-base font-sans leading-relaxed">
                    Biz haqimizda
                  </h6>
                  <div className="w-full flex-col justify-start lg:items-start items-center gap-3 flex">
                    <h2
                      className="text-indigo-700 text-4xl font-bold font-manrope leading-normal lg:text-start text-center">
                      EVOTEAM - bu IT xizmatlari, ta'lim va onlayn bozorni birlashtirgan kompaniya.</h2>
                    <p
                      className="text-gray-500 text-base font-normal leading-relaxed lg:text-start text-center">
                        Biz – Evo Team, zamonaviy IT va dasturlash olamida ilg‘or yechimlarni yaratishga intiluvchi jamoamiz. Ilm-fan, texnologiya va ijodkorlikni birlashtirib, dasturlash sohasi bo‘yicha sifatli ta’lim va xizmatlarni taqdim etamiz. Biz bilan o‘rganing, rivojlaning va IT olamida o‘z o‘rningizni toping!
                      </p>
                  </div>
                </div>
                <div className="w-full flex-col justify-center items-start gap-6 flex">
                  <div className="w-full justify-start items-center gap-8 grid md:grid-cols-2 grid-cols-1">
                    <div
                      className="w-full h-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                      <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">
                      2+ Yillik Tajriba
                      </h4>
                      <p className="text-gray-500 text-base font-normal leading-relaxed">
                      Innovatsion yechimlar yaratish bo‘yicha samarali faoliyat.
                      </p>
                    </div>
                    <div
                      className="w-full h-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                      <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">10+ Muvaffaqiyatli Loyihalar
                      </h4>
                      <p className="text-gray-500 text-base font-normal leading-relaxed">
                      Turli sohalarda amalga oshirilgan yuqori sifatli IT loyihalar.
                      </p>
                    </div>
                  </div>
                  <div className="w-full h-full justify-start items-center gap-8 grid md:grid-cols-2 grid-cols-1">
                    <div
                      className="w-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                      <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">
                      8+ Malakali Mutaxassislar
                      </h4>
                      <p className="text-gray-500 text-base font-normal leading-relaxed">
                      Dasturlash va texnologiyalar bo‘yicha tajribali jamoa.
                      </p>
                    </div>
                    <div
                      className="w-full h-full p-3.5 rounded-xl border border-gray-200 hover:border-gray-400 transition-all duration-700 ease-in-out flex-col justify-start items-start gap-2.5 inline-flex">
                      <h4 className="text-gray-900 text-2xl font-bold font-manrope leading-9">
                      100% Mamnun Mijozlar
                      </h4>
                      <p className="text-gray-500 text-base font-normal leading-relaxed">
                      Sifat va mijoz ehtiyojlariga yo‘naltirilgan xizmatlar.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:justify-start justify-center items-start flex">
              <div
                className="sm:w-[964px] w-full sm:h-[646px] h-full sm:bg-gray-100 rounded-3xl sm:border border-gray-200 relative mx-auto">
                <img className="sm:mt-5 sm:ml-5 w-full h-full object-cover"
                  src="/img/our-team.jpg" alt="EvoTeam Rasm" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Projects />
      <OurTeam />
      <Fotter />
    </>
  )
}

export default AboutPage
